import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const useBundleList = () =>
  useQuery({ queryKey: ["bundles"], queryFn: () => api.get("/bundles").then((r) => r.data) });

export function useBuyBundle() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return async (bundle) => {
    if (!user) {
      toast.message("Connectez-vous pour acheter cette offre");
      navigate("/connexion", { state: { from: "/offres" } });
      return;
    }
    try {
      const { data } = await api.post(`/bundles/${bundle.id}/purchase`);
      navigate(`/paiement/${data.order_number}`);
    } catch (e) {
      toast.error(apiError(e));
    }
  };
}
